import { IContainer } from '../../interface/container';
import { IFetcher, IFetchRequest, injectFetch, Method, ResponseTypes } from '../../interface/util';
import { IConfigAPI, injectConfigAPI } from '../../interface/config';
import { IMediumDiffRequestStatus, IMediaDiffResponse } from '../interface';
import { IMediaDiffAPI } from '../interface/mediaDiff';

interface IMediaDiffRequest {
    requestDto: {
        siteId: number;
        hash: string;
        requests: Array<{ id: string; mediumHash: string }>;
    };
}

function _request(params: {
    apiUrl: string;
    extension: string;
    authToken: string;
    siteId: number;
    siteHash?: string;
    existingMedia: Array<IMediumDiffRequestStatus>;
}): IFetchRequest {
    const mapMediumToBodyRequest = (
        medium: IMediumDiffRequestStatus,
    ): { id: string; mediumHash: string } => ({
        id: medium.id,
        mediumHash: medium.mediumHash,
    });

    const body: IMediaDiffRequest = {
        requestDto: {
            siteId: params.siteId,
            hash: params.siteHash ?? '',
            requests: (params.existingMedia ?? []).map(medium => mapMediumToBodyRequest(medium)),
        },
    };

    const req: IFetchRequest = {
        url: params.apiUrl + params.extension,
        method: 'POST' as Method,
        headers: [
            { name: 'Authorization', value: `Bearer ${params.authToken}` },
            { name: 'Content-Type', value: 'application/json' },
        ],
        body: JSON.stringify(body),
        expectedResponseType: 'json' as ResponseTypes,
    };

    return req;
}

function getMediaDiff(
    fetcher: Promise<IFetcher>,
    config: IConfigAPI,
    authToken: string,
    siteId: number,
    siteHash: string = '',
    existingMedia: Array<IMediumDiffRequestStatus> = [],
): Promise<IMediaDiffResponse> {
    return new Promise(async function (resolve, reject) {
        try {
            const fetcher = await injectFetch();
            const config = injectConfigAPI();

            const req = _request({
                apiUrl: config.url,
                extension: config.extension.mediaDiff,
                authToken,
                siteId,
                siteHash,
                existingMedia,
            });

            const response = await fetcher(req);

            resolve(response.payload as IMediaDiffResponse);
        } catch (error) {
            reject(error);
        }
    });
}

export default getMediaDiff;
